/**
 * Which part of a series an episode is, read from its title: "Mordet (2/8)", "Mordet - Del 2 av 8", "Mordet [2/8]",
 * "Mordet - Del 2". The API's detector found the series by exactly these markers, so every part of a series has one.
 * It mirrors the detector in podcast-api-go (internal/jobs/series/detect.go), and is only what the list falls back on
 * when the API does not send the number itself (the PHP API's series route does not).
 */
const KEYWORD = String.raw`(?:del|avsnitt|part|pt\.?|episode|ep\.?|kapitel)`;
const OF = String.raw`\s*(?:/|av|of)\s*`;

/** Patterns with the part and the total; a part that is not within 1 and the total is a date or a score, not a part */
const WITH_TOTAL = [
    new RegExp(String.raw`\(\s*${KEYWORD}?\s*(\d{1,3})${OF}(\d{1,3})\s*\)`, "i"),
    new RegExp(String.raw`\[\s*${KEYWORD}?\s*(\d{1,3})${OF}(\d{1,3})\s*\]`, "i"),
    new RegExp(String.raw`(?:^|[\s\-–—:|,])${KEYWORD}\s*(\d{1,3})${OF}(\d{1,3})\b`, "i"),
];
/** "Title - Del 2" at the very end of the title, with no total */
const TRAILING = /[\s\-–—:|,(]+(?:del|part|pt\.?)\s*(\d{1,3})\s*\)?\s*$/i;

export const partNumber = (title: string): number | null => {
    const text = title.replace(/\s+/g, " ").trim();
    for (const pattern of WITH_TOTAL) {
        const match = pattern.exec(text);
        if (match) {
            const part = Number(match[1]);
            const total = Number(match[2]);
            if (total >= 2 && total <= 100 && part >= 1 && part <= total) {
                return part;
            }
        }
    }
    const match = TRAILING.exec(text);
    if (match) {
        const part = Number(match[1]);
        return part >= 1 && part <= 100 ? part : null;
    }
    return null;
};
